import React from 'react';
import { host } from '@/config';
import { Category } from '@/types/article';

export type CategoryLabelVariant = 'primary' | 'secondary' | 'green';

interface CategoryLabelProps {
  category: Category;
  className?: string;
  variant?: CategoryLabelVariant;
}

const variantClasses: Record<CategoryLabelVariant, string> = {
  primary: 'bg-primary text-neutral',
  secondary: 'bg-[#824578] text-neutral',
  green: 'bg-[#78B596] text-neutral',
};

const categoryVariantMap: Record<string, CategoryLabelVariant> = {
  news: 'secondary',
  guide: 'green',
  guides: 'green',
};

export const getCategoryVariant = (categoryTitle?: string): CategoryLabelVariant => {
  if (!categoryTitle) return 'primary';
  return categoryVariantMap[categoryTitle.toLowerCase()] ?? 'primary';
};

export const CategoryLabel: React.FC<CategoryLabelProps> = ({ category, className, variant = 'primary' }) => {
  return (
    <a
      data-testid="article-category-link"
      href={`${host}${category.data.url}`}
      className={`${variantClasses[variant]} inline-block rounded-full px-8 py-3 text-center text-[14px] font-bold whitespace-nowrap ${className}`}
    >
      {category.data.title}
    </a>
  );
};
